import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { listVariables } from '../api/variables.js';

export function VariablesList(): JSX.Element {
  const { id = '' } = useParams<{ id: string }>();
  const q = useQuery({
    queryKey: ['variables', id],
    queryFn: () => listVariables(id),
    enabled: Boolean(id),
  });

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold">Variables (mapeo)</h2>
        <p className="text-xs text-slate-500 mt-1">
          Read-only desde admin. Para crear/editar mapeos, el tenant-admin lo hace desde su SPA en
          <code className="ml-1 rounded bg-slate-100 px-1 font-mono text-[11px]">.app.dev.zen.zervizdev.com/variables</code>.
        </p>
      </div>

      {q.isLoading && <p className="text-sm text-slate-500">Cargando…</p>}
      {q.error && (
        <p className="rounded border border-red-300 bg-red-50 p-2 text-sm text-red-800">
          {(q.error as Error).message}
        </p>
      )}
      {q.data && q.data.length === 0 && (
        <div className="rounded border border-dashed border-slate-300 p-6 text-sm text-slate-500">
          No hay variables configuradas para este tenant.
        </div>
      )}
      {q.data && q.data.length > 0 && (
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase text-slate-500">
            <tr>
              <th className="py-2">Nombre</th>
              <th>Origen</th>
              <th>ZE</th>
              <th>Destino</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {q.data
              .filter((v) => v.deletedAt === null)
              .map((v) => (
                <tr key={v.id} className="border-t border-slate-200">
                  <td className="py-2 font-medium">{v.name}</td>
                  <td className="font-mono text-[11px]">{v.sourceField}</td>
                  <td className="font-mono text-[11px]">{v.zeField}</td>
                  <td className="font-mono text-[11px]">{v.targetField ?? '—'}</td>
                  <td>
                    <span className="rounded bg-slate-100 px-2 py-0.5 text-[10px]">{v.status}</span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
